import React, { useEffect } from 'react';

const CenterToast = ({ message, actionLabel, onAction, onClose, duration = 15000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const t = setTimeout(() => onClose && onClose(), duration);
      return () => clearTimeout(t);
    }
  }, [duration, onClose]);

  return (
    <div className="fixed inset-0 z-[10000] pointer-events-none flex items-center justify-center p-4">
      <div className="pointer-events-auto w-full max-w-sm animate-tf-zoom-in">
        <div className="animated-border rounded-2xl p-[2px]">
          <div className="rounded-2xl bg-white/95 backdrop-blur-md shadow-2xl text-center p-5">
            <div className="text-slate-900 font-semibold mb-3 bengali-text">{message}</div>
            <div className="flex gap-2 justify-center mb-3">
              {actionLabel && (
            <button
              onClick={() => {
                if (onAction) onAction();
                if (onClose) onClose();
              }}
                  className="px-4 py-2 rounded-lg bg-orange-600 hover:bg-orange-700 text-white font-semibold bengali-text"
                >
                  {actionLabel}
                </button>
              )}
              <button
                onClick={onClose}
                className="px-4 py-2 rounded-lg border-2 border-slate-300 text-slate-700 hover:bg-slate-100 font-semibold bengali-text"
              >
                বন্ধ করুন
              </button>
            </div>
            <div className="h-1 bg-slate-200 rounded-full overflow-hidden">
              <div className="h-full bg-orange-600 animate-progress" style={{ animationDuration: `${duration}ms` }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenterToast;


